/* tslint:disable */
/* eslint-disable */
/**
 * Telematics API
 * Telematics services API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Tag update input
 * @export
 * @interface TagUpdateModel
 */
export interface TagUpdateModel {
    /**
     * 
     * @type {string}
     * @memberof TagUpdateModel
     */
    name: string;
    /**
     * 
     * @type {{ [key: string]: object; }}
     * @memberof TagUpdateModel
     */
    settings: { [key: string]: object; };
    /**
     * 
     * @type {number}
     * @memberof TagUpdateModel
     */
    id: number;
}

export function TagUpdateModelFromJSON(json: any): TagUpdateModel {
    return TagUpdateModelFromJSONTyped(json, false);
}

export function TagUpdateModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): TagUpdateModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'settings': json['settings'],
        'id': json['id'],
    };
}

export function TagUpdateModelToJSON(value?: TagUpdateModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'settings': value.settings,
        'id': value.id,
    };
}


